// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zA-z","tooltipWrapper":"AA-z","icon":"BA-z","tooltip":"CA-z","content":"DA-z"};